<template>
	<popup title="Delete page variation" @close="closePopup" medium>
		<template v-slot:content>
			<div>
				<label class="form_steps_label step_1">
					<span class="icon"></span> <p>Are you sure you want to delete this page variation <b>"{{name}}"</b>?</p>
				</label>
			</div>
		</template>
		<template v-slot:actions>
			<v-button label="Delete" slim :loading="loading" red border @click="deletePage" />
			<v-button label="Cancel" slim @click="closePopup" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import VSwitch from "@/components/base/v-switch";
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";

export default {
  name: "DeletePagePopup",
	components: {VButton, Popup},
	props:['funnelId','stepId','name', 'pageId'],
    mixins: [API],
    data() {
      return {
        loading: false,
      }
    },
    computed:{
    },
    methods: {
        closePopup() {
          this.$emit('close');
        },
        async deletePage() {
        	try {
		        this.loading = true
		        let {id, step} = this.$route.params

		        let result = await this.api.wsteps.deletePage(parseInt(this.funnelId), parseInt(this.stepId), parseInt(this.pageId));
		        if (!result.error) {
			        this.$emit('deleted');
			        this.$emit('close');
		        }
	        } catch (e) {
		        this.$warn(e);
	        } finally {
		        this.loading = false
	        }
        },
    },
}
</script>

<style lang="scss" scoped>
.form_steps_label {
	font-size: 15px;
}
</style>
